import { NavLink, useNavigate, Link } from "react-router-dom";

import {
  FiHome,
  FiTruck,
  FiUsers,
  FiClipboard,
  FiGrid,
  FiBarChart2,
  FiSettings,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiLogOut,
  FiPackage,
  FiMessageSquare,
  FiDollarSign,
  FiTrash2,
  FiShield,
  FiDatabase,
  FiFileText,
  FiX,
  FiRefreshCw,
  FiAlertTriangle,
} from "react-icons/fi";

import { MdOutlineGpsFixed } from "react-icons/md";

import { useState, useEffect } from "react";

import { hasPermission } from "../../pages/utils/permissions";

import { logoutUser } from "../../services/auth_service";

import { useSidebar } from "../../contexts/SidebarContext";

import "./Sidebar.css";


export default function Sidebar() {

  const [fleetOpen, setFleetOpen] = useState(() => localStorage.getItem("fleetMenuOpen") === "true");

  const [vehiclesOpen, setVehiclesOpen] = useState(() => localStorage.getItem("vehiclesMenuOpen") === "true");

  const [suppliersOpen, setSuppliersOpen] = useState(() => localStorage.getItem("suppliersMenuOpen") === "true");

  const [desktopCollapsed, setDesktopCollapsed] = useState(
    () => localStorage.getItem("sidebarDesktopCollapsed") === "true"
  );

  const [logoutConfirmOpen, setLogoutConfirmOpen] =
    useState(false);

  const [loggingOut, setLoggingOut] =
    useState(false);

  const navigate = useNavigate();

  const {
    mobileOpen,
    close,
  } = useSidebar();

  useEffect(() => {

    document.body.style.overflow =
      mobileOpen
        ? "hidden"
        : "";

    return () => {
      document.body.style.overflow = "";
    };

  }, [mobileOpen]);

  useEffect(() => {
    localStorage.setItem("fleetMenuOpen", String(fleetOpen));
  }, [fleetOpen]);

  useEffect(() => {
    localStorage.setItem("vehiclesMenuOpen", String(vehiclesOpen));
  }, [vehiclesOpen]);

  useEffect(() => {
    localStorage.setItem("suppliersMenuOpen", String(suppliersOpen));
  }, [suppliersOpen]);

  useEffect(() => {
    localStorage.setItem("sidebarDesktopCollapsed", String(desktopCollapsed));
  }, [desktopCollapsed]);



  const showFleet =
    hasPermission("drivers") ||
    hasPermission("vehicles") ||
    hasPermission("suppliers") ||
    hasPermission("recycle_bin");



  const canViewFollowups =
    hasPermission("followups");


  const canViewOutstanding =
    hasPermission("outstanding_view") ||
    hasPermission("outstanding_update");


  const closeMobile = () => {
    close();
  };


  const requestLogout = () => {
    setLogoutConfirmOpen(true);
  };


  const cancelLogout = () => {
    setLogoutConfirmOpen(false);
  };


  const confirmLogout = async () => {

    setLoggingOut(true);

    try {
      await logoutUser();
    } finally {
      navigate("/login");
    }
  };


  return (
    <>


      {mobileOpen && (
        <div
          className="sidebar-backdrop"
          onClick={closeMobile}
        />
      )}

      <div
        className={`sidebar ${
          mobileOpen ? "mobile-open" : ""
        } ${desktopCollapsed ? "desktop-collapsed" : ""}`}
      >

        <button
          type="button"
          className="sidebar-collapse-btn"
          onClick={() => setDesktopCollapsed((value) => !value)}
          aria-label={desktopCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          title={desktopCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {desktopCollapsed ? <FiChevronRight /> : <FiChevronLeft />}
        </button>

        <button
          type="button"
          className="sidebar-close-btn"
          onClick={closeMobile}
          aria-label="Close menu"
        >
          <FiX />
        </button>

        <div className="logo">

          <Link
            to="/dashboard"
            className="logo-link"
            onClick={closeMobile}
          >

            <img
              src="/assets/logo.jpg"
              alt="FleetPro Logo"
              className="logo-img"
            />

            <span className="logo-text">
              FleetManagementPro
            </span>

          </Link>

        </div>

        <nav>


          {hasPermission("dashboard") && (

            <div className="nav-group">

              <span className="nav-eyebrow">
                Overview
              </span>

              <NavLink
                to="/dashboard"
                onClick={closeMobile}
                title="Dashboard"
              >
                <FiHome />

                <span>
                  Dashboard
                </span>
              </NavLink>

            </div>

          )}

          {(
            showFleet ||
            hasPermission("assignments") ||
            canViewFollowups ||
            canViewOutstanding
          ) && (

            <div className="nav-group">

              <span className="nav-eyebrow">
                Operations
              </span>

              {showFleet && (

                <>

                  <div
                    className={`menu-parent ${
                      fleetOpen
                        ? "open"
                        : ""
                    }`}
                    title="Fleet"
                    onClick={() => {
                      if (desktopCollapsed) {
                        setDesktopCollapsed(false);
                        return;
                      }
                      setFleetOpen(!fleetOpen);
                    }}
                  >

                    <span className="menu-left">

                      <FiTruck />

                      <span>
                        Fleet
                      </span>

                    </span>

                    <FiChevronDown
                      className="menu-chevron"
                    />

                  </div>


                  <div
                    className={`submenu ${
                      fleetOpen
                        ? "expanded"
                        : ""
                    }`}
                  >

                    <div className="submenu-inner">

                      {hasPermission("drivers") && (

                        <NavLink
                          to="/drivers"
                          onClick={closeMobile}
                          title="Drivers"
                        >

                          <FiUsers />

                          <span>
                            Drivers
                          </span>

                        </NavLink>

                      )}

                      {hasPermission("vehicles") && (

                        <>

                          <div
                            className={`menu-parent nested ${
                              vehiclesOpen
                                ? "open"
                                : ""
                            }`}
                            title="Vehicles"
                            onClick={() => {
                              if (desktopCollapsed) {
                                setDesktopCollapsed(false);
                                return;
                              }
                              setVehiclesOpen(!vehiclesOpen);
                            }}
                          >

                            <span className="menu-left">

                              <FiTruck />

                              <span>
                                Vehicles
                              </span>

                            </span>

                            <FiChevronDown
                              className="menu-chevron"
                            />

                          </div>


                          <div
                            className={`submenu nested-submenu ${
                              vehiclesOpen
                                ? "expanded"
                                : ""
                            }`}
                          >

                            <div className="submenu-inner">
                              <NavLink
                                to="/vehicles"
                                onClick={closeMobile}
                                title="All Vehicles"
                              >

                                <FiTruck />

                                <span>
                                  All Vehicles
                                </span>

                              </NavLink>


              
                              {hasPermission(
                                "vehicle_documents"
                              ) && (

                                <NavLink
                                  to="/vehicle-documents"
                                  onClick={closeMobile}
                                  title="Vehicle Documents"
                                >

                                  <FiFileText />

                                  <span>
                                    Vehicle Documents
                                  </span>

                                </NavLink>

                              )}

                              {hasPermission(
                                "live_tracking"
                              ) && (

                                <NavLink
                                  to="/live-vehicles"
                                  onClick={closeMobile}
                                  title="Live Tracking"
                                >

                                  <MdOutlineGpsFixed />

                                  <span>
                                    Live Tracking
                                  </span>

                                </NavLink>

                              )}


                
                              {hasPermission(
                                "branch_overview"
                              ) && (

                                <NavLink
                                  to="/fleet-by-branch"
                                  onClick={closeMobile}
                                  title="Branch Overview"
                                >

                                  <FiGrid />

                                  <span>
                                    Branch Overview
                                  </span>

                                </NavLink>

                              )}

                            </div>

                          </div>

                        </>

                      )}

                      {hasPermission("suppliers") && (

                        <>

                          <div
                            className={`menu-parent nested ${
                              suppliersOpen
                                ? "open"
                                : ""
                            }`}
                            title="Suppliers"
                            onClick={() => {
                              if (desktopCollapsed) {
                                setDesktopCollapsed(false);
                                return;
                              }
                              setSuppliersOpen(!suppliersOpen);
                            }}
                          >

                            <span className="menu-left">

                              <FiPackage />

                              <span>
                                Suppliers
                              </span>

                            </span>

                            <FiChevronDown
                              className="menu-chevron"
                            />

                          </div>


                          <div
                            className={`submenu nested-submenu ${
                              suppliersOpen
                                ? "expanded"
                                : ""
                            }`}
                          >

                            <div className="submenu-inner">

                              <NavLink
                                to="/suppliers"
                                onClick={closeMobile}
                                title="All Suppliers"
                              >

                                <FiPackage />

                                <span>
                                  All Suppliers
                                </span>

                              </NavLink>

                              {canViewOutstanding && (

                                <NavLink
                                  to="/suppliers/outstanding"
                                  onClick={closeMobile}
                                  title="Outstanding Update"
                                >

                                  <FiDollarSign />

                                  <span>
                                    Outstanding Update
                                  </span>

                                </NavLink>

                              )}

                            </div>

                          </div>

                        </>

                      )}


               
                      {canViewFollowups && (

                        <NavLink
                          to="/followups"
                          onClick={closeMobile}
                        >

                          <FiRefreshCw />

                          <span>
                            Follow-ups
                          </span>

                        </NavLink>

                      )}

                    </div>

                  </div>

                </>

              )}


              {hasPermission("assignments") && (

                <NavLink
                  to="/vehicle-assignment"
                  onClick={closeMobile}
                  title="Vehicle Allotment"
                >

                  <FiClipboard />

                  <span>
                    Vehicle Allotment
                  </span>

                </NavLink>

              )}

            </div>

          )}


          {(
            hasPermission("staff_management") ||
            hasPermission("messages") ||
            hasPermission("master_data")
          ) && (

            <div className="nav-group">

              <span className="nav-eyebrow">
                Workforce
              </span>


              {hasPermission(
                "staff_management"
              ) && (

                <NavLink
                  to="/staff"
                  onClick={closeMobile}
                  title="Staff"
                >

                  <FiClipboard />

                  <span>
                    Staff
                  </span>

                </NavLink>

              )}


  
              {hasPermission(
                "master_data"
              ) && (

                <NavLink
                  to="/master-data"
                  onClick={closeMobile}
                  title="Master Data"
                >

                  <FiDatabase />

                  <span>
                    Master Data
                  </span>

                </NavLink>

              )}


    
              {hasPermission(
                "messages"
              ) && (

                <NavLink
                  to="/messages"
                  onClick={closeMobile}
                  title="Messages"
                >

                  <FiMessageSquare />

                  <span>
                    Messages
                  </span>

                </NavLink>

              )}

            </div>

          )}



          {(
            hasPermission("reports") ||
            hasPermission("settings") ||
            hasPermission("recycle_bin") ||
            hasPermission("auditlog")
          ) && (

            <div className="nav-group">

              <span className="nav-eyebrow">
                Insights
              </span>


       
              {hasPermission("reports") && (

                <NavLink
                  to="/reports"
                  onClick={closeMobile}
                  title="Reports"
                >

                  <FiBarChart2 />

                  <span>
                    Reports
                  </span>

                </NavLink>

              )}


    
              {hasPermission("auditlog") && (

                <NavLink
                  to="/audit-log"
                  onClick={closeMobile}
                  title="Audit"
                >

                  <FiShield />

                  <span>
                    Audit
                  </span>

                </NavLink>

              )}

              {hasPermission("recycle_bin") && (

                <NavLink
                  to="/recycle-bin"
                  onClick={closeMobile}
                  title="Recycle Bin"
                >

                  <FiTrash2 />

                  <span>
                    Recycle Bin
                  </span>

                </NavLink>

              )}

              {hasPermission("settings") && (

                <NavLink
                  to="/settings"
                  onClick={closeMobile}
                  title="Settings"
                >

                  <FiSettings />

                  <span>
                    Settings
                  </span>

                </NavLink>

              )}

            </div>

          )}


          <div className="sidebar-footer">

            <button
              type="button"
              className="logout-btn"
              onClick={requestLogout}
            >

              <FiLogOut />

              <span>
                Logout
              </span>

            </button>

          </div>

        </nav>

      </div>



      {logoutConfirmOpen && (

        <div
          className="logout-modal-overlay"
          onClick={cancelLogout}
        >

          <div
            className="logout-modal"
            onClick={(e) =>
              e.stopPropagation()
            }
          >

            <div className="logout-modal__icon">
              <FiAlertTriangle />
            </div>

            <h2 className="logout-modal__title">
              Log out of your account?
            </h2>

            <p className="logout-modal__text">
              You'll need to sign in again to
              access FleetManagementPro.
            </p>

            <div className="logout-modal__actions">

              <button
                type="button"
                className="logout-modal__btn logout-modal__btn--cancel"
                onClick={cancelLogout}
                disabled={loggingOut}
              >
                Cancel
              </button>

              <button
                type="button"
                className="logout-modal__btn logout-modal__btn--confirm"
                onClick={confirmLogout}
                disabled={loggingOut}
              >

                {loggingOut
                  ? "Logging out…"
                  : "Log out"}

              </button>

            </div>

          </div>

        </div>

      )}

    </>
  );
}
